import { UnSubscribable } from '@core/un-subscrible';
import { Directive, OnInit, OnDestroy, Self, Output, EventEmitter } from '@angular/core';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { assign } from 'lodash';
import { takeUntil } from 'rxjs/operators';

// TODO: refactor when have time
@Directive({
    selector: 'mat-paginator, [eigPaginatorDirective]'
})
export class EigPaginatorDirective extends UnSubscribable implements OnInit, OnDestroy {

    @Output()
    pageChange = new EventEmitter<EigPageEvent>();
    constructor(@Self() private matPaginator: MatPaginator) {
        super();
    }

    shadowPageIndex = 0;

    get eigPaginator(): MatPaginator {
        this.matPaginator.pageIndex = 0;
        return this.matPaginator;
    }

    ngOnInit(): void {
        this.matPaginator.hasPreviousPage = () => {
            return this.shadowPageIndex >= 1;
        };

        this.matPaginator.hasNextPage = () => {
            return this.matPaginator.length >= this.matPaginator.pageSize;
        };

        this.matPaginator
        .page
        .pipe(takeUntil(this.unsubscribeAll))
        .subscribe((page: PageEvent) => {
            this.pageChange
            .next({
                previousPageIndex: this.matPaginator.pageIndex,
                pageIndex: this.matPaginator.pageIndex,
                pageSize: this.matPaginator.pageSize,
                length: this.matPaginator.length,
                shadowPageIndex: this.shadowPageIndex
            });
        });

        this.matPaginator.nextPage = () => {
            this.matPaginator.pageIndex = this.shadowPageIndex;
            if (!this.matPaginator.hasNextPage()) { return; }
            const previousPageIndex = this.matPaginator.pageIndex;
            this.matPaginator.pageIndex++;
            this.shadowPageIndex++;
            this.pageChange.next({
                previousPageIndex,
                pageIndex: this.matPaginator.pageIndex,
                pageSize: this.matPaginator.pageSize,
                length: this.matPaginator.length,
                shadowPageIndex: this.shadowPageIndex
            });
        };

        this.matPaginator.previousPage = () => {
            this.matPaginator.pageIndex = this.shadowPageIndex;
            if (!this.matPaginator.hasPreviousPage()) { return; }
            const previousPageIndex = this.matPaginator.pageIndex;
            this.shadowPageIndex--;
            this.matPaginator.pageIndex--;
            this.pageChange.next({
                previousPageIndex,
                pageIndex: this.matPaginator.pageIndex,
                pageSize: this.matPaginator.pageSize,
                length: this.matPaginator.length,
                shadowPageIndex: this.shadowPageIndex
            });
        };

        this.matPaginator.firstPage = () => {
            const previousPageIndex = this.matPaginator.pageIndex;
            this.matPaginator.pageIndex = 0;
            this.shadowPageIndex = 0;
            this.pageChange.next({
                previousPageIndex,
                pageIndex: this.matPaginator.pageIndex,
                pageSize: this.matPaginator.pageSize,
                length: this.matPaginator.length,
                shadowPageIndex: this.shadowPageIndex
            });
        };
    }
}

export class EigPageEvent extends PageEvent {
    shadowPageIndex = 0;
}
